import FormattedText from './formattedText';

export default FormattedText;
